import { Component, OnInit, Input, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { MinLengthValidator, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessorBase } from '../shared/value-accessor/value-accessor-base';

@Component({
  selector: 'sem-iban',
  templateUrl: './sem-iban.component.html',
  styleUrls: ['./sem-iban.component.css'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: SemIBANComponent, multi: true }
  ]
})

export class SemIBANComponent extends ValueAccessorBase<string> implements OnInit {

  @Input() fields: any;
  @Input() showTooltipValue: any;
  disResults: any[] = [];
  @Input() maxLength: string = "";


  maxLengthInteger: number = 1000; //default value

  addResult() {
    this.disResults.push(this.checkForDisabled(this.getAttribute('name')));
  }

  super() { }

  ngOnInit() {

    super.ngOnInit();

    if (this.showTooltipValue == null || typeof this.showTooltipValue == "undefined") {
      this.showTooltipValue = false;
    }

    try {
      if (this.maxLength && this.maxLength.length > 0) {
        this.maxLengthInteger = parseInt(this.maxLength.trim());
      }
    } catch {

    }

    var placeholder: string = this.checkPlaceholder();

    if (placeholder && placeholder.length > 0) {
      if (placeholder.toLowerCase().startsWith("si56")) {
        var cv = this.dfms.getValue(this.model, this.getAttribute('name').split(".")[1]);

        if (typeof cv == "undefined" || !cv || cv.length == 0) {
          if (!this.value || typeof this.value == "undefined" || this.value.length == 0) {
            this.value = "SI56";
            this.dfms.assign(this.model, this.getAttribute('name').split(".")[1], this.value, true);
          }
        }

      }
    }

  }

  protected override valueChanged(): void {

  }

  onTextChange(event: Event) {

    const input = event.target as HTMLInputElement;

    if(input.value.length < 4){
      input.value = "SI56";
      return;
    }

    input.value = input.value
      .toUpperCase() // Convert input to uppercase
      .replace(/[^a-zA-Z0-9]/g, '') // Remove non-alphanumeric characters
      .replace(/(.{4})/g, '$1-') // Insert hyphen after every 4 characters
      .slice(0, this.maxLengthInteger);
    if (input.value.endsWith('-')) {
      input.value = input.value.slice(0, -1); // Remove trailing hyphen
    }

    this.checkAfterInput(input.value);
  }

  checkAfterInput(value) {
    let attName = this.getAttribute("name");

    let control = this.dfms.globalForm.controls[attName];

    if (control !== null && typeof control !== "undefined") {
      this.dfms.globalForm.controls[attName].setValue(value);
      this.dfms.globalForm.controls[attName].updateValueAndValidity();
    }

    this.dfms.updateControlsValidationArray(attName, value);

    if (typeof this.onValueChangeEval != "undefined" && this.onValueChangeEval) {
      eval(this.onValueChangeEval);
    }
  }

}
